import React from 'react';

/**
 * Reusable Status Badge Component
 */
const StatusBadge = ({ status, children }) => {
  const statusVariants = {
    active: 'bg-green-100 text-green-800 border-green-200',
    inactive: 'bg-gray-100 text-gray-800 border-gray-200',
    pending: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    success: 'bg-green-100 text-green-800 border-green-200',
    error: 'bg-red-100 text-red-800 border-red-200',
    warning: 'bg-orange-100 text-orange-800 border-orange-200',
    info: 'bg-blue-100 text-blue-800 border-blue-200',
    // Wizard submission statuses (database-aligned)
    submitted: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    reviewed: 'bg-blue-100 text-blue-800 border-blue-200',
    contacted: 'bg-purple-100 text-purple-800 border-purple-200',
    converted: 'bg-green-100 text-green-800 border-green-200',
    closed: 'bg-gray-100 text-gray-800 border-gray-200',
    // Legacy statuses (for other parts of app)
    new: 'bg-purple-100 text-purple-800 border-purple-200',
    qualified: 'bg-green-100 text-green-800 border-green-200',
    won: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    lost: 'bg-red-100 text-red-800 border-red-200',
    on_hold: 'bg-yellow-100 text-yellow-800 border-yellow-200'
  };

  const variant = statusVariants[status] || statusVariants.inactive;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${variant}`}>
      {children || status}
    </span>
  );
};

export default StatusBadge;
